import type { ReactNode } from 'react';
import { AdminBreadcrumbs, type AdminBreadcrumbItem } from './admin-breadcrumbs.js';

export interface AdminPageHeaderProps {
  title: string;
  description?: string;
  breadcrumbs?: AdminBreadcrumbItem[];
  actions?: ReactNode;
}

/** The `<h1>` for every admin page lives here -- exactly one per page, satisfying the semantic-heading-outline requirement (Part 16) without every page having to remember it. */
export function AdminPageHeader({ title, description, breadcrumbs, actions }: AdminPageHeaderProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="mb-1.5">
            <AdminBreadcrumbs items={breadcrumbs} />
          </div>
        )}
        <h1 className="text-2xl font-bold tracking-tight text-gray-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
